const formats = {
	MLA: 'https://drive.google.com/file/d/1IC__7XY-357vMXqNePdvYsn88Ctokbeh/view',
	APA: 'https://docs.google.com/document/d/1oxVEDdBwmfnxzdle8XPPPRm5TaHY2exN',
	Chicago: 'https://docs.google.com/document/d/1oTxTP3xzIHXYo3c-2Gzj4jmNk4ZykrfR',
	Harvard: 'https://docs.google.com/document/d/13ZaW_ETbrwnOQqUAs0xB7HV2ZL_B-3-B',
};

export default formats;



// WEBPACK FOOTER //
// ./src/constants/formats.js